
const LIGHT = { r: 0xfd, g: 0xee, b: 0xdd }; // low lost marks
const DEEP = { r: 0xc0, g: 0x39, b: 0x2b }; // high lost marks

const clamp01 = (n) => Math.max(0, Math.min(1, n));

export const getSeverityColor = (fraction) => {
  const t = clamp01(fraction);
  const r = Math.round(LIGHT.r + (DEEP.r - LIGHT.r) * t);
  const g = Math.round(LIGHT.g + (DEEP.g - LIGHT.g) * t);
  const b = Math.round(LIGHT.b + (DEEP.b - LIGHT.b) * t);
  return `rgb(${r}, ${g}, ${b})`;
};

// CSS gradient string for the "Higher lost marks / Lower lost marks" legend swatch.
export const SEVERITY_GRADIENT = `linear-gradient(to right, ${getSeverityColor(0)}, ${getSeverityColor(0.5)}, ${getSeverityColor(1)})`;
